import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import result from 'lodash/result';
import VisibilitySensor from 'react-visibility-sensor';

import { OPTION_IMPRESSION, OPTION_CLICK } from 'lib/analytics/events';

const propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  hide: PropTypes.bool,
  trackEvent: PropTypes.func,
};

const defaultProps = {
  hide: false,
  selected: false,
  onClick: () => {},
  trackEvent: () => {},
};

class SavePaymentMethod extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.trackEvent = this.trackEvent.bind(this);
  }

  trackEvent(event) {
    const { trackEvent, selected } = this.props;
    trackEvent({
      ...event,
      name: 'SavePaymentMethod',
      properties: {
        selected: result(selected, 'toString', 'false'),
      },
    });
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick();
    this.trackEvent(OPTION_CLICK);
  }

  handleVisibilityChange(visible) {
    if (visible) {
      this.trackEvent(OPTION_IMPRESSION);
    }
  }

  render() {
    const { hide } = this.props;

    const checkboxClassNames = cx({
      checkbox: true,
      selected: this.props.selected,
      hidden: hide,
    });

    return (
      <div className="form-group mbm non-paypal" onClick={this.handleClick}>
        <VisibilitySensor onChange={this.handleVisibilityChange} partialVisibility>
          <div className={checkboxClassNames}>
            <label>
              <FormattedMessage
                id="checkout.save-payment"
                defaultMessage="Save payment method"
              />
            </label>
          </div>
        </VisibilitySensor>
      </div>
    );
  }
}

SavePaymentMethod.propTypes = propTypes;
SavePaymentMethod.defaultProps = defaultProps;
export default SavePaymentMethod;
